module.exports = __webpack_public_path__ + "img/title-shiba.8a5078b5.png";